export default function () {
  const widgetName = 'galleryWidget';
  const widgetOpts = galleryWidgetOpts;

  const linkedImages = true;
  const linkNewTab = false;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      $(`#${widgetName}`).find('.card-content').remove();

      if (widgetData.length <= 0) {
        $(`#${widgetName}`).remove();
      } else {
        changeFormatCards(widgetData);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
  });

  function changeFormatCards(data) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $card = $(this);
      if (!data[x].URL) {
        $card.removeAttr('href');
      }
      if (!linkNewTab) {
        $card.removeAttr('target');
      }
      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
